import { render, staticRenderFns } from "./orderSubmit.vue?vue&type=template&id=19961a2e&scoped=true&"
import script from "./orderSubmit.vue?vue&type=script&lang=js&"
export * from "./orderSubmit.vue?vue&type=script&lang=js&"
import style0 from "./orderSubmit.vue?vue&type=style&index=0&id=19961a2e&scoped=true&lang=css&"
import style1 from "./orderSubmit.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19961a2e",
  null
  
)

export default component.exports